import { normalizeIotaObjectId } from "./iota-types.js";
const IOTA_DECIMALS = 9;
const NANOS_PER_IOTA = BigInt(1e9);
const MOVE_STDLIB_ADDRESS = "0x1";
const IOTA_FRAMEWORK_ADDRESS = "0x2";
const IOTA_SYSTEM_ADDRESS = "0x3";
const IOTA_CLOCK_OBJECT_ID = normalizeIotaObjectId("0x6");
const IOTA_SYSTEM_MODULE_NAME = "iota_system";
const IOTA_TYPE_ARG = `${IOTA_FRAMEWORK_ADDRESS}::iota::IOTA`;
const IOTA_SYSTEM_STATE_OBJECT_ID = normalizeIotaObjectId("0x5");
export {
  IOTA_CLOCK_OBJECT_ID,
  IOTA_DECIMALS,
  IOTA_FRAMEWORK_ADDRESS,
  IOTA_SYSTEM_ADDRESS,
  IOTA_SYSTEM_MODULE_NAME,
  IOTA_SYSTEM_STATE_OBJECT_ID,
  IOTA_TYPE_ARG,
  MOVE_STDLIB_ADDRESS,
  NANOS_PER_IOTA
};
//# sourceMappingURL=constants.js.map
